
import { STOCK_ADJUSTMENT_MENU_ITEM } from "@/consts";
import StockAdjustmentTable from "@/components/barcodeSystem/stockAdjustment/StockAdjustmentTable.vue";
import StockAdjustmentFilters from "@/components/barcodeSystem/stockAdjustment/StockAdjustmentFilters.vue";
import StockAdjustmentsActions from "@/components/barcodeSystem/stockAdjustment/StockAdjustmentsActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import StockAdjustmentModule from "@/store/modules/barcodeSystem/stockAdjustment";
import Component from "vue-class-component";
import permissions from "@/security/permissions";

const stockAdjustmentModuleState = getModule(StockAdjustmentModule);

@Component({
  components: {
    StockAdjustmentTable,
    StockAdjustmentFilters,
    StockAdjustmentsActions
  }
})
export default class StockAdjustmentSearch extends Vue {
  showStockAdjustmentFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  STOCK_ADJUSTMENT_MENU_ITEM: any = STOCK_ADJUSTMENT_MENU_ITEM;

  get fields() {
    return stockAdjustmentModuleState.fields;
  }

  async created() {
  }
  
  async loadMoreAdjustments() {
    await stockAdjustmentModuleState.setLoading(true);
    await stockAdjustmentModuleState.getStockAdjustments(null);
    await stockAdjustmentModuleState.setLoading(false);
  }

  async onSort(s) {
    await stockAdjustmentModuleState.setLoading(true);
    await stockAdjustmentModuleState.applyListSort(s);
    await stockAdjustmentModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    stockAdjustmentModuleState.toggleField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.STOCK_ADJUSTMENT_MENU_ITEM;
  }

  get dataRetreived() {
    if(stockAdjustmentModuleState.data)
      return true;
    return false;
  }
}


